import { checkSessionSync, getTokenBack, logout } from "../utils/auth";
import { onError } from "@apollo/client/link/error";
import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloLink,
  concat
} from "@apollo/client";
import store from "../store/store";
import { backendUrl } from "../utils/enviroments";

const INVALID_TOKEN_ERROR: string = "TOKEN DE AUTHORIZACION INVALIDO";

export const createApolloClient = () => {
  const httpLink = new HttpLink({
    uri: backendUrl + "/graphql",
  });

  const authMiddleware = new ApolloLink((operation, forward) => {
    store.dispatch({ type: "globalLoading", payload: true });
    if (
      operation.operationName !== "LOGIN" &&
      operation.operationName !== "RESTOREPASS"
    ) {
      operation.setContext({
        headers: {
          authorization: "Bearer " + getTokenBack(),
        },
      });
      checkSessionSync();
    }
    return forward(operation).map((data) => {
      store.dispatch({ type: "globalLoading", payload: false });
      return data;
    });
  });

  const logoutLink = onError((networkError: any) => {
    store.dispatch({ type: "globalLoading", payload: false });
    if (networkError) {
      if (
        networkError.response &&
        networkError.response.errors &&
        networkError.response.errors.some(
          (error: any) => error.message === INVALID_TOKEN_ERROR
        )
      ) {
        logout();
      }
    }
  });

  return new ApolloClient({
    link: concat(authMiddleware, logoutLink.concat(httpLink)),
    cache: new InMemoryCache(),
  });
};
